
import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { ActiveTabUtil } from '@commoncore/utils/ActiveTabUtil';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONFIG } from '@env-properties/environment-config';

@Component({
  standalone:true,
  selector: 'lib-pop-up-tabbed-view',
  templateUrl: './pop-up-tabbed-view.component.html',
  styleUrls: ['./pop-up-tabbed-view.component.scss'],
  imports: []
})
export class PopUpTabbedViewComponent implements OnInit {
  static tabbedRef: any;
  universalService:any;
  router:any;
  localStorageSvc:any;
  popUpTabDetails:any=[];
  tabData:any;
  userData:any;
  activeTabUtil:any;
  http:any;

  constructor(public globalService:GlobalService) {
    PopUpTabbedViewComponent.tabbedRef = this;
    this.setEnvObjects(globalService);
    
   }

  ngOnInit(): void {
    this.userData = this.localStorageSvc.getUserData(true);
    this.fetchJSONContents();
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.activeTabUtil = new ActiveTabUtil();
    this.http = globalService.getHttpClientRef();
  }

  registerEvents(){
    console.log("inside registering events")
    let classRef = PopUpTabbedViewComponent.tabbedRef;
    AppEvents.on(EventsList.COPY_TABBED_VIEW, function(){
      console.log("loading shared files sent tab from COPY_TABBED_VIEW")
      classRef.renderTabbedView("Copy");
    })
    AppEvents.on(EventsList.ADD_TO_ALBUM_MODAL_TABBED_VIEW,function(){
      console.log("loading tab from add to board modal")
      classRef.renderTabbedView("addToAlbum");
    })
  }
  
  renderTabbedView(tabName){
    var url = window.location.href;
    if(url.includes('sharedwithme')){
      console.log("check true")
      tabName = "sharedWithMe"
    } else if(this.userData && this.userData["jcEntInfo"] && this.universalService.enableTeamFolders){
      console.log("include tf")
      tabName = "TeamFoldersCopy"
    }
    switch(tabName){
      case "Copy":
        this.popUpTabDetails = this.tabData["CopyTabDetails"];
        console.log("pop up tab details are ==>>",this.popUpTabDetails)
        var tab = this.popUpTabDetails[0];
        this.switchTab(tab)
        break;
      case "sharedWithMe":
        this.popUpTabDetails = this.tabData["SharedWithMeCopyTabDetails"];
        console.log("pop up tab details are ==>>",this.popUpTabDetails)
        var tab = this.popUpTabDetails[0];
        this.switchTab(tab)
        break;
      case "TeamFoldersCopy":
        this.popUpTabDetails = this.tabData["CopyTabDetailsWithTeamFolder"];
        var url = window.location.href;
        //Hide shared tab for TF
        if(url.includes('teamfolder') || url.includes('tf')){
          for (var item of this.popUpTabDetails) {
            if(item.id == "sharedwithme") {
              item.isDisabled = "disabled"
            }
          }
        }else {
          for (var item of this.popUpTabDetails) {
            if(item.id == "sharedwithme") {
              item.isDisabled = "";
            }
          }
        }
        console.log("pop up tab details are ==>>",this.popUpTabDetails)
        var tab = this.popUpTabDetails[0];
        this.switchTab(tab);
        break;
      case "addToAlbum":
        this.popUpTabDetails = this.tabData["AlbumsTabbedDetails"];
        console.log("pop up tab details are ==>>",this.popUpTabDetails)
        var tab = this.popUpTabDetails[0];
        this.switchTab(tab);
        break;
      default:
        console.log("not part of any tabs")
    }
  }

  switchTab(tab){
    this.universalService.showLoader = true;
    this.activeTabUtil.setActiveTabForPopUp(tab,this.popUpTabDetails);
    this.universalService.PopUpTabClicked = tab["id"];
    AppEvents.emit(EventsList.POP_UP_TAB_CLICKED,this.popUpTabDetails)
  }

  fetchJSONContents(){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(ENV_CONFIG.jsonUrls.tabbedView).subscribe(
        suc=>{
          self.tabData = suc["TabbedView"];
          self.registerEvents();
          AppEvents.emit(EventsList.POPUP_TABBED_VIEW_READY)
          // self.renderTabbedView(tabName);
        }
      )
    })
  }
  

}
